"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _images = require("../common_features/assets/images");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _event = require("../common_features/utility/event");
var _helper = require("../common_features/utility/helper");
var _Services = require("../common_features/utility/Services");
var _CommonAlertListComponent = _interopRequireDefault(require("../components/CommonAlertListComponent"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CommonAlertList = () => {
  const {
    stores
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const {
    phoneNumber
  } = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails;
    return (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : _state$userDetails.data;
  });
  const {
    UserNotifyPref
  } = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails2;
    return (_state$userDetails2 = state.userDetails) === null || _state$userDetails2 === void 0 ? void 0 : _state$userDetails2.data;
  });
  const {
    generalAlerts
  } = (0, _reactRedux.useSelector)(state => state.alert);
  const {
    userScreenPref
  } = (0, _reactRedux.useSelector)(state => state.role);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const [listItem, setListItem] = (0, _react.useState)([]);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const handleBack = () => {
    if (userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View")) {
      if (userInfo.userType === 5) {
        navigate(_RoutePath.default.techDispatcher.useLink);
      } else {
        navigate(_RoutePath.default.storeDashboard.useLink);
      }
    } else {
      navigate(_RoutePath.default.admin.useLink);
    }
  };
  const clickHandler = data => {
    dispatch((0, _alertReducer.selectedAlertData)(data));
    navigate(_RoutePath.default.StoreAlertsDetails.useLink);
  };
  const fetchNotification = () => {
    (0, _Services.GetNotifications)().then(res => {
      dispatch((0, _alertReducer.generalAlertData)(res.data.rows));
      generateList(res.data.rows);
      setIsLoading(false);
    }).catch(e => {
      setIsLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    _event.eventEmitter.subscribe("socketOnMessage", data => {
      if (["PRODUCT", "GENERAL"].includes(data.eventType)) {
        fetchNotification();
      }
    });
    setIsLoading(true);
    fetchNotification();
    return () => {};
  }, []);
  (0, _react.useEffect)(() => {
    var _UserNotifyPref$pref, _UserNotifyPref$pref2, _UserNotifyPref$pref3, _UserNotifyPref$pref4;
    UserNotifyPref && (0, _Services.notificationsListState)({
      email: UserNotifyPref === null || UserNotifyPref === void 0 ? void 0 : (_UserNotifyPref$pref = UserNotifyPref.pref) === null || _UserNotifyPref$pref === void 0 ? void 0 : _UserNotifyPref$pref.email,
      sms: UserNotifyPref === null || UserNotifyPref === void 0 ? void 0 : (_UserNotifyPref$pref2 = UserNotifyPref.pref) === null || _UserNotifyPref$pref2 === void 0 ? void 0 : _UserNotifyPref$pref2.sms,
      helpfulTips: UserNotifyPref === null || UserNotifyPref === void 0 ? void 0 : (_UserNotifyPref$pref3 = UserNotifyPref.pref) === null || _UserNotifyPref$pref3 === void 0 ? void 0 : _UserNotifyPref$pref3.helpfulTips,
      isNotifyIconClicked: true,
      phoneNumber: (UserNotifyPref === null || UserNotifyPref === void 0 ? void 0 : (_UserNotifyPref$pref4 = UserNotifyPref.pref) === null || _UserNotifyPref$pref4 === void 0 ? void 0 : _UserNotifyPref$pref4.sms) === true ? phoneNumber : " "
    }).then(data => {
      console.log(data);
    }).catch(error => {
      console.log(error);
    });
  }, [UserNotifyPref]);
  (0, _react.useEffect)(() => {
    generateList(generalAlerts);
  }, [generalAlerts]);
  const generateList = generalAlerts => {
    let newList = [];
    generalAlerts.forEach(alert => {
      const currentAlarmStore = stores.filter(store => (store === null || store === void 0 ? void 0 : store.storeId) === (alert === null || alert === void 0 ? void 0 : alert.storeId))[0];
      const text = alert !== null && alert !== void 0 && alert.text ? alert === null || alert === void 0 ? void 0 : alert.text : alert === null || alert === void 0 ? void 0 : alert.alarmText;
      const data = {
        id: alert === null || alert === void 0 ? void 0 : alert.id,
        variant: "tile",
        isRead: alert === null || alert === void 0 ? void 0 : alert.read,
        alertheading: currentAlarmStore === null || currentAlarmStore === void 0 ? void 0 : currentAlarmStore.name,
        alertMessageType: (0, _helper.setAlarmSeveritySign)(alert === null || alert === void 0 ? void 0 : alert.severity),
        alertText: text === null || text === void 0 ? void 0 : text.alertTitle,
        Description: text === null || text === void 0 ? void 0 : text.notifications_list,
        alertImageLeft: _helper.ALERT_ICONS_MAP[alert === null || alert === void 0 ? void 0 : alert.severity],
        alertImageRight: _images.ArrowRight.default,
        createdAt: alert === null || alert === void 0 ? void 0 : alert.createdAt,
        date: (0, _helper.getDate)(alert === null || alert === void 0 ? void 0 : alert.createdAt),
        deviceId: alert === null || alert === void 0 ? void 0 : alert.deviceId,
        systemId: alert === null || alert === void 0 ? void 0 : alert.systemId,
        type: alert === null || alert === void 0 ? void 0 : alert.type,
        alarmText: alert === null || alert === void 0 ? void 0 : alert.text,
        severity: alert === null || alert === void 0 ? void 0 : alert.severity,
        storeId: alert === null || alert === void 0 ? void 0 : alert.storeId,
        isFromNotification: true,
        text: alert === null || alert === void 0 ? void 0 : alert.text,
        fullWidth: true
      };
      newList = [...newList, {
        ...data,
        onClick: () => clickHandler({
          ...data
        })
      }];
    });
    setListItem(newList);
  };
  return /*#__PURE__*/_react.default.createElement(_CommonAlertListComponent.default
  // storeName={selectedStore.name}
  // storeAddress={selectedStore.address}
  , {
    navHeadingText: "".concat(userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? "Store" : "Home", " Dashboard"),
    SubNavHeadingText: "GENERAL ALERTS",
    SubNavHeadingTitle: "ServiceConnect",
    handleBack: handleBack,
    storeAlertList: listItem,
    isLoading: isLoading
  });
};
var _default = exports.default = CommonAlertList;